import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, isRef as _isRef, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "inline-select-wrapper position-relative d-inline-block" }
const _hoisted_2 = { class: "text-truncate" }

import {getCurrentInstance, nextTick, onMounted, ref, watch} from 'vue';


const __default__ = {
    name: "InlineSelect"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: /*@__PURE__*/_mergeModels({
    placeholder: {},
    withoutPlaceholder: { type: Boolean },
    disabled: { type: Boolean },
    options: {}
  }, {
    "modelValue": {},
    "modelModifiers": {},
  }),
  emits: ["update:modelValue"],
  setup(__props: any) {

let props = __props;

let model = _useModel<any>(__props, "modelValue");


let buffer = ref<HTMLSpanElement>();
let isMounted = ref(false);
let label = ref<string>();


onMounted(() => {
    isMounted.value = true;
    updateLabel();
});

let instance = getCurrentInstance().proxy;

function updateLabel() {
    nextTick(() => {
        if (isMounted.value) {
            let value = model.value;
            if (!value || !value.length) {
                let placeholder = instance.$el.querySelector(".el-select__placeholder") as HTMLElement;
                if (placeholder) {
                    value = placeholder.innerText.trim();
                } else {
                    value = "Выберите"
                }
            } else {
                let option = props.options.find(item => item.value == value);
                if (option) {
                    value = option.label ?? option.value;
                }
            }
            label.value = value;
        }
    });
}

watch(model, () => updateLabel());


return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", {
      ref_key: "buffer",
      ref: buffer,
      class: _normalizeClass({
                'buffer text-truncate': true,
                'placeholder': !(_unref(model) && (typeof _unref(model) != 'string' || _unref(model).length)) && !__props.withoutPlaceholder
            })
    }, _toDisplayString(_unref(label)), 3),
    _createVNode(_component_el_select, {
      modelValue: _unref(model),
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(model) ? (model).value = $event : model = $event)),
      class: "inline-select",
      disabled: __props.disabled,
      placeholder: __props.placeholder,
      "fit-input-width": false
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.options, (option) => {
          return (_openBlock(), _createBlock(_component_el_option, {
            value: option.value,
            label: option.label ?? option.value
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, _toDisplayString(option.label ?? option.value), 1)
            ]),
            _: 2
          }, 1032, ["value", "label"]))
        }), 256))
      ]),
      _: 1
    }, 8, ["modelValue", "disabled", "placeholder"])
  ]))
}
}

})